import { useDashData } from "../hooks/useDashData";
import PageHeader from "../components/layout/PageHeader";
import CampaignsTable from "../components/dashboard/CampaignsTable";

export default function Campaigns() {
  const { data: campaigns } = useDashData("/analytics/campaigns");
  const { data: services } = useDashData("/services", { withDates: false });

  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader title="Campaign Explorer"
        subtitle="Every campaign across Meta & Google — filter, search & export" />
      <CampaignsTable campaigns={campaigns || []} services={services || []} />
    </div>
  );
}
